import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useBrain } from "@/contexts/ui/brain";

const APP_PATH_PREFIXES = ["/genie-hub/", "/user-hub/"];

const isAppPath = (href?: string): href is string =>
  !!href && APP_PATH_PREFIXES.some((prefix) => href.startsWith(prefix));

interface BrainLinkProps {
  href?: string;
  children?: ReactNode;
}

/**
 * Links inside Your Genie's replies. A link to a screen in the app navigates
 * in place and closes the chat panel, which would otherwise cover the screen
 * it points at; anything else opens in a new tab.
 */
const BrainLink = ({ href, children }: BrainLinkProps) => {
  const { closeBrain } = useBrain();

  if (isAppPath(href)) {
    return (
      <Link to={href} onClick={closeBrain} className="text-primary underline">
        {children}
      </Link>
    );
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-primary underline">
      {children}
    </a>
  );
};

export default BrainLink;
